module.exports = __webpack_public_path__ + "img/maru_blue.664a3bf4.png";